import VersionInfo from "./VersionInfo";

export default VersionInfo;
